import { render, staticRenderFns } from "./AffiliateExternal.vue?vue&type=template&id=284b4ac2&scoped=true&"
import script from "./AffiliateExternal.vue?vue&type=script&lang=js&"
export * from "./AffiliateExternal.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateExternal.vue?vue&type=style&index=0&id=284b4ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b4ac2",
  null
  
)

export default component.exports